import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const SAFETY_CASE_LANG: {
  SAFETY_CASE_ADD_BREADCRUMB: MvnCodeFE;
  SAFETY_CASE_ADD_SUCC: MvnCodeFE;
  SAFETY_CASE_ADD_FAIL: MvnCodeFE;
  SAFETY_CASE_SAVE_SUCC: MvnCodeFE;
  SAFETY_CASE_SAVE_FAIL: MvnCodeFE;
  SAFETY_CASE_CRF_VIEW_FAIL: MvnCodeFE;
  SAFETY_CASE_IDENTIFIER_AUTO_GENERATE_INPUT_DESCRIPTION: MvnCodeFE;
  SAFETY_CASE_ADD_CRF_DROPDOWN_PLACEHOLDER: MvnCodeFE;
  SAFETY_CASE_ADD_CRF_CHANGE_WARNING: MvnCodeFE;
  SAFETY_CASE_VIEW_NOT_AUTHORIZED: MvnCodeFE;
} = {
  SAFETY_CASE_ADD_BREADCRUMB: {
    ko: "등록된 Case를 확인하고 관리할 수 있습니다.",
    en: "Create and manage cases",
  },
  SAFETY_CASE_ADD_SUCC: {
    ko: "CASE가 성공적으로 추가되었습니다.",
    en: "Case has been created successfully.",
  },
  SAFETY_CASE_ADD_FAIL: {
    ko: "CASE 추가에 실패했습니다. ({message})",
    en: "Failed to create case. ({message})",
  },
  SAFETY_CASE_SAVE_SUCC: {
    ko: "CASE가 성공적으로 저장되었습니다.",
    en: "Case has been saved successfully.",
  },
  SAFETY_CASE_SAVE_FAIL: {
    ko: "CASE 저장에 실패했습니다. ({message})",
    en: "Failed to save case. ({message})",
  },
  SAFETY_CASE_CRF_VIEW_FAIL: {
    ko: "Report 정보를 불러오는데 실패했습니다. ({message})",
    en: "Failed to load report information. ({message})",
  },
  SAFETY_CASE_IDENTIFIER_AUTO_GENERATE_INPUT_DESCRIPTION: {
    ko: "고유식별 보고자관리번호는 Case 생성 시 자동 부여됩니다.",
    en: "Case identifier is automatically assigned when creating a case.",
  },
  SAFETY_CASE_ADD_CRF_DROPDOWN_PLACEHOLDER: {
    ko: "Report를 선택해주세요.",
    en: "Please choose a report.",
  },
  SAFETY_CASE_ADD_CRF_CHANGE_WARNING: {
    ko: "Report Form을 변경하였습니다. 작성 중인 내용이 삭제되었습니다.",
    en: "The Report Form has been changed. The contents has been deleted.",
  },
  SAFETY_CASE_VIEW_NOT_AUTHORIZED: {
    ko: "Case를 보기 위해서는 {privileges} 권한이 필요합니다.",
    en: "You need {privileges} privilege(s) to view case details.",
  },
};

MvnCodeInitiate(SAFETY_CASE_LANG);
